/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Phone_RequiredInputs */

const en_clients_validation_phone_required = /** @type {(inputs: Clients_Validation_Phone_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone 1 is required.`)
};

const pt_br2_clients_validation_phone_required = /** @type {(inputs: Clients_Validation_Phone_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone 1 é obrigatório.`)
};

/**
* | output |
* | --- |
* | "Phone 1 is required." |
*
* @param {Clients_Validation_Phone_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_phone_required = /** @type {((inputs?: Clients_Validation_Phone_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Phone_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_phone_required(inputs)
	return pt_br2_clients_validation_phone_required(inputs)
});